import useBudgetStore from "../Modules/FinanceManager/Budget/Store/useBudgetStore";
import useAccountStore from "../Modules/FinanceManager/Accounts/Store/useAccountStore";
import useTransactionStore from "../Modules/FinanceManager/Transactions/Store/useTransactionStore";
import useGoalStore from "../Modules/FinanceManager/SavingGoals/Store/useGoalStore";
import useReportingStore from "../Modules/FinanceManager/Dashboard/Store/useReportingStore";
import { useFinancialPlanningStore } from "../Modules/FinanceManager/FinancialPlanning/Store/useFinancialPlanningStore";
import useAssetStore from "../Modules/HomeManager/Assets/Store/useAssetStore";
import useMealPlanStore from "../Modules/HomeManager/MealPlanning/Store/useMealPlanStore";
import useEventStore from "../Modules/HomeManager/Events/Store/useEventStore";
import useTaskStore from "../Modules/HomeManager/TaskChores/Store/useTaskStore";
import { useGroupStore } from "../Modules/Configurations/Categories/Store/useGroupStore";

const getCurrentPeriod = () => new Date().toISOString().slice(0, 7);

export function resetWorkspaceScopedState() {
  useAccountStore.getState().resetSession?.();

  useBudgetStore.setState({
    budgets: [],
    lastFetchedBudgets: null,
    selectedBudget: {
      details: {},
      categories: [],
      isLoading: true,
      error: "",
      isBudgetSaved: false,
      sharedStatus: "",
      budgetId: null,
    },
    budgetId: null,
    activeTab: "expense",
    currentDate: getCurrentPeriod(),
    route: "personal",
  });

  useTransactionStore.setState({
    transactions: [],
    loading: false,
    error: null,
    lastFetchedTransactions: null,
    cachedTransactions: {},
    hasRecalculatedBalances: false,
    lastRecalculatedAt: null,
    openingBalanceByAccount: {},
    allTransactionsByAccount: {},
    lastFetchedByAccountKey: {},
    lastFetchedAllByAccount: {},
  });

  useGoalStore.setState({
    goals: [],
    loading: false,
    error: null,
    lastFetched: null,
  });

  useReportingStore.setState({
    income: 0,
    expenses: 0,
    savings: 0,
    netBalance: 0,
    goalsProgress: [],
    accountBalances: {},
    transactions: [],
    budgets: [],
    insights: [],
    trends: { income: [], expenses: [] },
    loading: false,
    error: null,
  });

  useFinancialPlanningStore.getState().reset?.();

  useAssetStore.setState({
    assets: [],
    loading: false,
    error: null,
  });

  useMealPlanStore.setState({
    mealPlans: [],
    recipes: [],
    currentWeekPlan: null,
    loading: false,
    error: null,
  });

  useEventStore.setState({
    events: [],
    loading: false,
    error: null,
  });

  useTaskStore.setState({
    tasks: [],
    loading: false,
    error: null,
  });

  useGroupStore.getState().unsubscribeAll?.();
  useGroupStore.setState({
    data: {},
    cache: {},
    activeGroups: [],
    loading: false,
    error: null,
    success: null,
    unsubscribers: {},
  });
}
